import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const dashboardViewEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "dashboard-view-entrypoint" */ './src/index.tsx'),
	),
	getPreloadProps: () => {
		return {};
	},
});
